module.exports = __webpack_public_path__ + "static/media/main-img1.f43d92cf.jpeg";